import { Controller } from "@hotwired/stimulus"

const DISMISSAL_KEY = "posture_loop_mobile_unsupported_dismissed"

function isMobileDevice() {
  const ua = navigator.userAgent

  if (/Android|iPhone|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
    return true
  }

  // iPadOS often reports as Macintosh with touch.
  return navigator.maxTouchPoints > 1 && /Macintosh/.test(ua)
}

export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    if (!isMobileDevice()) return
    if (localStorage.getItem(DISMISSAL_KEY) === "1") return

    this.show()
  }

  dismiss() {
    localStorage.setItem(DISMISSAL_KEY, "1")
    this.close()
  }

  show() {
    if (this.hasDialogTarget) {
      this.dialogTarget.showModal()
    }
  }

  close() {
    if (this.hasDialogTarget) {
      this.dialogTarget.close()
    }
  }
}
